"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CsvUploadConfigModel", {
    enumerable: true,
    get: function() {
        return CsvUploadConfigModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _integration = require("./integration");
const CsvUploadConfigModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    csv_fields_to_skip: _zod.z.array(_zod.z.string()).optional(),
    current_user: _zod.z.instanceof(_bson.ObjectId).optional(),
    deactivate_user_on_missing: _zod.z.boolean().optional(),
    emails: _zod.z.array(_zod.z.string()).optional(),
    field_mapping_list: _zod.z.array(_zod.z.object({
        csv_column_name: _zod.z.string(),
        performyard_custom_field_name: _zod.z.string()
    })).optional(),
    field_mapping_object: _zod.z.object({}).optional(),
    integration_type: _integration.IntegrationName,
    is_testing: _zod.z.boolean().optional(),
    name: _zod.z.string(),
    secondary_user_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    status: _zod.z.string(),
    updated_at: _zod.z.date()
});
